import React, { useContext, useEffect, useState } from "react";
import styled from 'styled-components';
import moment from "moment";
import { Container, Col } from "reactstrap";
import * as toastr from "toastr";

import * as arrow from "Placements/Assets/svg/arrow-down.svg"
import * as close from "Placements/Assets/svg/close-btn.svg"

import ItemTestResult from 'Placements/Components/ItemTestResult'
import FilterTests from "Placements/Components/FilterTests";
import Loader from "Placements/Components/Loader";
import DatePicker from "Placements/Fields/Forms/DatePicker.field";

import UserContext from "Placements/User.context"
import API from "Placements/API";
import getConfig from "Placements/Utils/GetRequestConfig.util"
import { ContainerFlex } from "Placements/Styles/Global.style";
import Breadcrumb from "Placements/Components/Breadcrumb";


const EvaluationList = styled.div`
    width: 70vw;
    max-width: 1024px;
    margin: 0 auto 50px;
    background-color: #fff;
    padding: 14px;
    position: relative;
    color: #66279b;

    h2{
        display: block;
        margin-block-start: 0.67em;
        margin-block-end: 0.67em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
        font-size: 30px;
        margin: 0 14px;
    }

    .close-results{
        width: 48px;
        height: 48px;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        background-color: ${(props) => props.theme.main.mainGreen};
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }

    footer{
        color: ${(props) => props.theme.main.mainGreen};
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        padding: 40px 0;
        font-weight: 500;

        div{
            font-size: 18px;
            cursor: pointer;
        }
    }
`;

const Wrapper = styled.div`
    display: -webkit-box;
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    justify-content: space-between;
`;

const TestList = () => {

    const dataContext: any = useContext(UserContext);
    const [isLoading, setLoading] = useState(false);
    const [listTest, setListTest] = useState([]);
    const [idTest, setIdTest] = useState("");
    const [language, setLanguage] = useState("");
    const [countElements, setCountElements] = useState(12);
    const [page, setPage] = useState(1);
    const [dateInit, setDateInit] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const [isFiltered, setIsFiltered] = useState(false);
    const [disableLoad, setDisableLoad] = useState(false);

    useEffect(() => {
        if (dataContext === null) {
            window.location.href = "#/login"
        }
    }, []);

    useEffect(() => {
        if (countElements !== 12)
            fetchTests();

    }, [countElements]);


    useEffect(() => {
        if (idTest === "" && dateInit === null && dateEnd === null && language === "")
            clearFilter();


        if (dateInit !== null && dateEnd !== null && dateEnd - dateInit < 0) {
            toastr.warning("Intervalo de datas inválido")
            return
        }

        fetchTests();

    }, [idTest, dateInit, dateEnd, language]);

    const fetchTests = async () => {
        try {

            setLoading(true);

            const filter = {

                idTeste: idTest,
                idioma: language,
                qtdElementos: countElements,
                codUnidadeYazigi: dataContext.usuario.Cod_Unidade_Yazigi,
                pagina: page,
                dataInicio: dateInit === null ? "" : moment(dateInit).format("yyyy-MM-DD"),
                dataFim: dateEnd === null ? "" : moment(dateEnd).format("yyyy-MM-DD")

            };

            const response = await API.Admin.GetTestsFilter(filter, getConfig());

            setDisableLoad(response.data.length === 0 ? true : false);
            setListTest(response.data);

        } catch (error) {

            toastr.error('Não foi possível obter os testes.');
            console.error(error);
            window.location.href = "#/login";

        } finally {

            setLoading(false);

        }

    };

    const handleLoadMore = () => {

        if (listTest.length === countElements) {
            setCountElements(countElements + 12);
            // setPage(page + 1);
        } else {
            setDisableLoad(true);
        }

    };

    const handleInput = (e: any) => {

        const idInput = e.target.id;

        setIsFiltered(true);

        switch (idInput) {
            case "test": setIdTest(e.target.value); break;
            case "language": setLanguage(e.target.value); break;
        }

    }

    const handleDatePicker = (keystone: any, date: any) => {

        setIsFiltered(true);

        switch (keystone) {
            case "date-init": setDateInit(date); break;
            case "date-end": setDateEnd(date); break;
        }

    }

    const clearFilter = () => {
        setDateInit(null);
        setDateEnd(null);
        setIdTest("");
        setLanguage("");
        setPage(1);
        setCountElements(12);
        setIsFiltered(false);
        setDisableLoad(false);

    }

    const handleTest = (test: any) => {
        window.location.href = `#/admin/test-list/${test.Id_Teste_Usuario}`
    }

    const getBreadcrumb = () => {
        return [
            { path: "", label: "Listagem de Testes" },
        ]
    }

    return (
        <ContainerFlex>
            <Col md={10}>
                {isLoading && <Loader />}
                <Breadcrumb links={getBreadcrumb()} />
                <FilterTests>
                    <form>
                        <div className="filters">
                            <div className="item">
                                <div className="container-icon">
                                    <input type="number" className="input -alt" placeholder="Nº do teste" id="test" onChange={handleInput} value={idTest} />
                                </div>
                            </div>
                            <div className="item">
                                <div className="container-icon">
                                    <DatePicker value={dateInit} placeholder="De" className="input -alt" keystone="date-init" onChange={handleDatePicker} />
                                </div>
                            </div>
                            <div className="item">
                                <div className="container-icon">
                                    <DatePicker value={dateEnd} placeholder="Até" className="input -alt" keystone="date-end" onChange={handleDatePicker} />
                                </div>
                            </div>
                            <div className="item -dropdown">
                                <select name="language" id="language" className="select input -alt" onChange={handleInput} value={language}>
                                    <option value="" disabled hidden>Idioma</option>
                                    <option value="Espanhol">Espanhol</option>
                                    <option value="Ingles">Inglês</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </FilterTests>
                <EvaluationList>
                    {isFiltered ? <h2>Resultado(s)</h2> : <h2>Últimos testes</h2>}
                    {isFiltered ? <div className="close-results" onClick={clearFilter}> <img src={close} /> </div> : ""}
                    <Wrapper>
                        {listTest.map((test, index) => (
                            <ItemTestResult key={index}>
                                <div className="box" onClick={() => handleTest(test)}>
                                    <p className="number">Test {test.Id_Teste_Usuario}</p>
                                    <p className="date">{moment(test.Data).format('DD/MM/yyyy hh:mm:ss')}</p>
                                    <p className="student">{test.Nome}</p>
                                    <p className="value">
                                        {test.NomeParte} // 
                                        {test.Resultado === null ? "" : String((test.Resultado * 100).toFixed(1)) + "%"}
                                    </p>
                                    {test.Nivel === null ? <p className="in-progress">(Teste em Andamento...)</p> : <p className="level"> {test.Nivel} </p>}
                                </div>
                            </ItemTestResult>
                        ))}
                    </Wrapper>
                    <footer>
                        {!disableLoad ? <div onClick={handleLoadMore}> Carregar mais <img src={arrow} style={{ marginLeft: "20px" }} /></div> : ""}
                    </footer>
                </EvaluationList>
            </Col>
        </ContainerFlex>
    );

}

export default TestList;